<template>
  <div>
    <div ref="popupContent">
      <template v-if="currentMov.deviceNumber">
        <div class="mov-popup">
          <div class="header">
            <p>{{currentMov.deviceName || '--'}}</p>
          </div>
          <div class="content">
            <p class="info">设备串号：{{currentMov.deviceNumber || '--'}}</p>
            <p class="info">总割草面积：{{currentMov.mowingAreaTotal || '--'}} ㎡</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import vjmap from 'vjmap'
export default {
  name: 'MovingCenter',
  data () {
    return {
      movList: [],
      currentMov: {}
    }
  },
  filters: {},
  watch: {
    '$route.path' (newPath, oldPath) {
      // 路由变化时的处理逻辑
      console.log('路由从', oldPath, '变化到', newPath)
      this.$nextTick(() => {
        this.$event.$emit('mov-change', this.currentMov)
      })
    }
  },
  computed: {},
  created () {
    this.$event.$on('mov-list-init', this.addList)
    this.$event.$on('mov-change', this.showMarkerPopup)
  },
  destroyed () {
    this.removeMarkers()
    this.$event.$off('mov-list-init', this.addList)
    this.$event.$off('mov-change', this.showMarkerPopup)
  },
  methods: {
    initMap () {
      return new Promise((resolve) => {
        if (this._map) {
          resolve()
        } else {
          const interval = setInterval(() => {
            this._map = this.$parent.$children[0]._map
            if (this._map) {
              interval && clearInterval(interval)
              resolve()
            }
          }, 200)
        }
      })
    },
    getMarkerEl (iconPath, w, h) {
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage = `url(${iconPath})`
      el.style.width = w || '40px'
      el.style.height = h || '40px'
      el.style.backgroundSize = '100%'
      return el
    },
    // 删除地图列表打点信息
    removeMarkers () {
      if (this.movList && this.movList.length) {
        this.movList.forEach(item => {
          item.marker && item.marker.remove()
          item.sMarker && item.sMarker.remove()
          item.polygon && item.polygon.remove()
        })
      }
      this.movList = []
      if (this.markerPopup) {
        this.markerPopup.remove()
      }
      this.markerPopup = null
    },
    addList (list) {
      this.initMap().then(() => {
        this.removeMarkers()
        this.markerPopup = new vjmap.Popup({ closeButton: false })
        ;(list || []).forEach(item => {
          let marker = null
          let sMarker = null
          let polygon = null
          if (item.longitude && item.latitude) {
            const icon = require('../../assets/img/icon/mow.png')
            const el = this.getMarkerEl(icon, '36px', '48px')
            marker = new vjmap.Marker({
              element: el,
              anchor: 'bottom'
            })
            marker.extData = { deviceNumber: item.deviceNumber }
            marker.setLngLat([item.longitude, item.latitude]).addTo(this._map)
            marker.on('click', this.overlayClick)
          }
          if (item.chargeLongitude && item.chargeLatitude) {
            const icon = require('../../assets/img/icon/mowStation.png')
            const el = this.getMarkerEl(icon, '42px', '39px')
            sMarker = new vjmap.Marker({
              element: el,
              anchor: 'bottom'
            })
            sMarker.extData = { deviceNumber: item.deviceNumber }
            sMarker.setLngLat([item.longitude, item.latitude]).addTo(this._map)
            sMarker.on('click', this.overlayClick)
          }
          if (item.locationList && item.locationList.length) {
            const lngLats = []
            const fenceCode = []
            item.locationList.forEach(loc => {
              const ind = fenceCode.indexOf(loc.fenceCode)
              if (ind >= 0) {
                lngLats[ind].points.push([loc.longitude, loc.latitude])
              } else {
                lngLats[fenceCode.length] = {
                  points: [],
                  properties: { deviceNumber: item.deviceNumber }
                }
                lngLats[fenceCode.length].points.push([loc.longitude, loc.latitude])
                fenceCode.push(loc.fenceCode)
              }
            })
            polygon = new vjmap.Polygon({
              data: lngLats,
              fillColor: '#6CB3AD',
              fillOpacity: 0.4,
              fillOutlineColor: '#6CB3AD'
            })
            polygon.addTo(this._map)
            polygon.clickPopup(f => {
              this.showMarkerPopup(f.properties)
              return ''
            }, { anchor: 'bottom', closeButton: false })
          }
          this.movList.push({ info: { ...item }, marker, sMarker, polygon })
        })
        this.$parent.$children[0].setFitMarkers()
        // 如果有当前选中事件，则展示
        this.currentMov.deviceNumber && this.showMarkerPopup(this.currentMov)
      })
    },
    overlayClick (e) {
      this.showMarkerPopup(e.target.extData, true)
    },
    showMarkerPopup (data, isClick) {
      // 切换割草机或者重新渲染时，展示popup
      if (data.deviceNumber && (this.currentMov.deviceNumber !== data.deviceNumber || !this.markerPopup.isOpen())) {
        const ind = this.movList.findIndex(item => item.info.deviceNumber === data.deviceNumber)
        if (ind >= 0) {
          const obj = this.movList[ind]
          this.currentMov = { ...obj.info }
          this.$nextTick(() => {
            this.markerPopup.setDOMContent(this.$refs.popupContent)
            const marker = obj.sMarker || obj.marker
            if (marker) {
              marker.setPopup(this.markerPopup)
              if (!this.markerPopup.isOpen()) {
                marker.togglePopup()
              }
              if (!isClick) {
                this._map.setCenter(marker.getLngLat())
              }
            }
          })
        } else {
          this.currentMov = {}
        }
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .mov-popup {
    width: 320px;
    height: auto;
    color: var(--map-popup-font-color);
    background: var(--map-popup-bg);
    box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
    border-radius: 10px;
    margin: 0px 21px 39px;
    .header{
      display: flex;
      height: auto;
      min-height: 34px;
      line-height: 14px;
      background: #2E3C55;
      border-radius: 10px 10px 0px 0px;
      padding: 10px 19px;
      color: #FFFFFF;
      p:nth-of-type(1){
        width: auto;
        max-width: 300px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .content{
      padding: 16px 19px;
      font-size: 12px;
      .info {
        position: relative;
        padding-left: 13px;
        margin-bottom: 19px;
        &::after{
          position: absolute;
          content: '';
          left: 0px;
          top: calc(50% - 2px);
          width: 4px;
          height: 4px;
          background: var(--header-bar-title-color);
          border-radius: 2px;
        }
      }
    }
  }
</style>
